
<div class="group-standings-select-views">
  <span [pTooltip]="'view-modes.detail' | translate" tooltipPosition="left"
    class="pi pi-bars" (click)="selectedView = 'detail'"></span>
  <span [pTooltip]="'view-modes.collapsed' | translate" tooltipPosition="top" 
    class="pi pi-table" (click)="selectedView = 'collapsed'"></span>
</div>
<!-- detail view -->
@if(selectedView === 'detail') {
  <div class="flex flex-col gap-8">
    @for (group of standingsGroups; track group.groupId) {
      <div class="flex flex-col gap-4">
        <p class="group-name">{{ group.groupName }}</p>
        <p-table
          [value]="group.standings || []"
          [rows]="10"
          [loading]="loading"
          [style]="{ width: '100%' }"
          stripedRows
        >
          <ng-template #header>
            <tr>
              <th>#</th>
              <th>{{ 'field.team' | translate }}</th>
              <th class="stats-col" [pTooltip]="'field.played' | translate" tooltipPosition="top">
                {{ 'field.played-abbr' | translate }}
              </th>
              <th class="stats-col" [pTooltip]="'field.won' | translate" tooltipPosition="top">
                {{ 'field.won-abbr' | translate }}
              </th>
              <th class="stats-col" [pTooltip]="'field.drawn' | translate" tooltipPosition="top">
                {{ 'field.drawn-abbr' | translate }}
              </th>
              <th class="stats-col" [pTooltip]="'field.lost' | translate" tooltipPosition="top">
                {{ 'field.lost-abbr' | translate }}
              </th>
              <th class="stats-col" [pTooltip]="'field.points' | translate" tooltipPosition="top">
                {{ 'field.points-abbr' | translate }}
              </th>
              <th class="last-matches-col">{{ 'field.lastMatches' | translate }}</th>
              @if(allowChangePositions) {
                <th class="move-standing-col"></th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-standing let-rowIndex="rowIndex">
            <tr [ngClass]="{'highlight': filter() && _.includes(_.toLower(_.deburr(standing.teamName)), filter())}">
              <td class="stats-col">{{ rowIndex + 1 }}</td>
              <td>{{ standing.teamName }}</td>
              <td class="stats-col">{{ standing.played }}</td>
              <td class="stats-col">{{ standing.won }}</td>
              <td class="stats-col">{{ standing.drawn }}</td>
              <td class="stats-col">{{ standing.lost }}</td>
              <td class="stats-col">{{ standing.points }}</td>
              <td class="last-matches-col">
                @for(status of standing.lastMatches; track $index) {
                  @switch (status) {
                    @case ('WIN') {
                      <span class="pi pi-check win last-matches-icon"></span>
                    }
                    @case ('DRAW') {
                      <span class="pi pi-minus draw last-matches-icon"></span>
                    }
                    @case('LOST') {
                      <span class="pi pi-times last-matches-icon lost"></span>
                    }
                  }
                }
              </td>
              <!-- move team -->
              @if(allowChangePositions) {
                <td class="move-standing-col">
                  <div class="flex items-center justify-end gap-2">
                    <p-button icon="pi pi-arrows-alt" rounded severity="secondary"
                      [pTooltip]="'button.change-team-position' | translate" tooltipEvent="hover" tooltipPosition="top"
                      (click)="toggleMoveTeamPop($event, standing, group)"></p-button>
                  </div>
                </td> 
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
}
<!-- summary view -->
@else {
  <div class="collapsed-view">
    @for (group of standingsGroups; track group.groupId) {
      <div class="flex flex-col flex-1 gap-4">
        <p class="group-name">{{ group.groupName }}</p>
        <p-table
          [value]="group.standings || []"
          [rows]="10"
          [loading]="loading"
          [style]="{ width: '100%' }"
          stripedRows
        >
          <ng-template #header>
            <tr>
              <th>#</th>
              <th>{{ 'field.team' | translate }}</th>
              <th class="stats-col">{{ 'field.points' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-standing let-rowIndex="rowIndex">
            <tr>
              <td class="stats-col">{{ rowIndex + 1 }}</td>
              <td>{{ standing.teamName }}</td>
              <td class="stats-col">{{ standing.points }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
}

<!-- move team popup -->
<p-popover #moveTeamPop>
  <div class="p-confirmpopup-content">
    <ul class="list-none p-2 m-0 flex flex-col">
      @for(position of standingToMovePositions; track $index) {
        @if(position !== standingToMove?.groupPosition) {
          <li class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border" (click)="moveStanding(position)">
            <div>
              <span class="font-medium">{{ 'field.position' | translate }} {{ position }}</span>
            </div>
          </li>
        }
      }
    </ul>
  </div>
</p-popover>
